import { Path, useFormContext } from 'react-hook-form';
import { Card, IconButton, IconName, Stack, Typography } from '@optimus-web/core';
import { lt, FormCheckboxField } from '@mews/framework';
import { useCalendarService } from '@mews-commander/ui';
import { DateField } from '@mews-commander/form';
import { GenerateContractFormValues } from '../types';

interface SelectedItemCardProps {
    name?: string;
    expirationDateFieldName: Path<GenerateContractFormValues>;
    expirationDateEnabledFieldName: Path<GenerateContractFormValues>;
    onRemove: () => void;
    nameIcons?: React.ReactNode;
    cardIcons?: React.ReactNode;
}

export const SelectedItemCard = ({
    name,
    expirationDateFieldName,
    expirationDateEnabledFieldName,
    onRemove,
    nameIcons,
    cardIcons,
}: SelectedItemCardProps) => {
    const { watch } = useFormContext<GenerateContractFormValues>();
    const calendarService = useCalendarService();
    const today = calendarService.getCurrentDate();
    const isExpirationDateEnabled = watch(expirationDateEnabledFieldName);

    return (
        <Card padding="200">
            <Stack vertical spacing="100">
                <Stack distribution="space-between">
                    <Stack itemAlignment="center" spacing="100">
                        <Typography textStyle="titleSmallStrong" as="p">
                            {name}
                        </Typography>
                        {nameIcons}
                    </Stack>
                    <Stack>
                        {cardIcons}
                        <IconButton icon={IconName.Delete} type="button" variant="ghost" onClick={onRemove} />
                    </Stack>
                </Stack>
                <Stack vertical spacing="100" itemAlignment="start">
                    <FormCheckboxField name={expirationDateEnabledFieldName}>
                        {lt('ContractsGenerateExpirationDateEnabledCheckboxLabel')}
                    </FormCheckboxField>
                    {isExpirationDateEnabled && <DateField mode="iso" minDate={today} name={expirationDateFieldName} />}
                </Stack>
            </Stack>
        </Card>
    );
};
